const restaurant = {
  restaurant: "रेस्टोरेंट", // translated 
  restaurants: "रेस्टोरेंट", // translated 
  category: "वर्ग", // translated 
  score: "अंक", // translated 
  priceQuartile: "मूल्य चतुर्थक", // translated 
  scoreLowestFirst: "स्कोर (सबसे कम से शुरू)", // translated 
  scoreHighestFirst: "स्कोर (सबसे अधिक पहले)", // translated 
  priceLowestFirst: "क़ीमत: पहला सबसे कम)", // translated 
  priceHighestFirst: "मूल्य: उच्चतम पहले)", // translated 
  allPrices: "सभी कीमतें", // translated 
  reserve: "संरक्षित", // translated 
  dining: "भोजन", // translated 
};


export default restaurant;
